import { call, put, takeEvery } from "redux-saga/effects";

import { createAction } from "@reduxjs/toolkit";

import axios from "axios";
import buildUrl from "build-url-ts";

import {
  FetchTeamsDashboardErrorResponse,
  FetchTeamsDashboardRequest,
  FetchTeamsDashboardResponse,
  FetchTeamsLearnersErrorResponse,
  FetchTeamsLearnersRequest,
  FetchTeamsLearnersResponse,
  FetchTeamsLearningsErrorResponse,
  FetchTeamsLearningsRequest,
  FetchTeamsLearningsResponse,
  FetchTeamsMostEnrolledLearningsErrorResponse,
  FetchTeamsMostEnrolledLearningsRequest,
  FetchTeamsMostEnrolledLearningsResponse,
  FetchTeamsSkillsErrorResponse,
  FetchTeamsSkillsRequest,
  FetchTeamsSkillsResponse,
} from "src/types/coaching/reports/teams";

import {
  FETCH_CREATIONS_DASHBOARD_REPORT_REQUEST,
  FETCH_CREATIONS_LEARNERS_REPORT_REQUEST,
  FETCH_CREATIONS_LEARNINGS_INSIGHTS_REPORT_REQUEST,
  FETCH_CREATIONS_TOP_LEARNINGS_REPORT_REQUEST,
  FETCH_LEARNINGS_DASHBOARD_REPORT_REQUEST,
  FETCH_LEARNINGS_INSIGHTS_REPORT_REQUEST,
  FETCH_LEARNINGS_LEADERBOARD_REPORT_REQUEST,
  FETCH_LEARNINGS_POPULAR_REPORT_REQUEST,
  FETCH_LEARNINGS_SKILLS_REPORT_REQUEST,
  FETCH_LEARNINGS_TIMELINE_REPORT_REQUEST,
  FETCH_SKILLS_REPORT_REQUEST,
  FETCH_TEAMS_DASHBOARD_REPORT_REQUEST,
  FETCH_TEAMS_LEADERBOARD_REPORT_REQUEST,
  FETCH_TEAMS_LEARNERS_REPORT_REQUEST,
  FETCH_TEAMS_LEARNINGS_REPORT_REQUEST,
  FETCH_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_REQUEST,
  FETCHING_CREATIONS_DASHBOARD_REPORT_FAILED,
  FETCHING_CREATIONS_DASHBOARD_REPORT_SUCCEEDED,
  FETCHING_CREATIONS_LEARNERS_REPORT_FAILED,
  FETCHING_CREATIONS_LEARNERS_REPORT_SUCCEEDED,
  FETCHING_CREATIONS_LEARNINGS_INSIGHTS_REPORT_FAILED,
  FETCHING_CREATIONS_LEARNINGS_INSIGHTS_REPORT_SUCCEEDED,
  FETCHING_CREATIONS_TOP_LEARNINGS_REPORT_FAILED,
  FETCHING_CREATIONS_TOP_LEARNINGS_REPORT_SUCCEEDED,
  FETCHING_LEARNINGS_DASHBOARD_REPORT_FAILED,
  FETCHING_LEARNINGS_DASHBOARD_REPORT_SUCCEEDED,
  FETCHING_LEARNINGS_INSIGHTS_REPORT_FAILED,
  FETCHING_LEARNINGS_INSIGHTS_REPORT_SUCCEEDED,
  FETCHING_LEARNINGS_LEADERBOARD_REPORT_FAILED,
  FETCHING_LEARNINGS_LEADERBOARD_REPORT_SUCCEEDED,
  FETCHING_LEARNINGS_POPULAR_REPORT_FAILED,
  FETCHING_LEARNINGS_POPULAR_REPORT_SUCCEEDED,
  FETCHING_LEARNINGS_SKILLS_REPORT_FAILED,
  FETCHING_LEARNINGS_SKILLS_REPORT_SUCCEEDED,
  FETCHING_SKILLS_REPORT_FAILED,
  FETCHING_SKILLS_REPORT_SUCCEEDED,
  FETCHING_TEAMS_DASHBOARD_REPORT_FAILED,
  FETCHING_TEAMS_DASHBOARD_REPORT_SUCCEEDED,
  FETCHING_TEAMS_LEADERBOARD_REPORT_FAILED,
  FETCHING_TEAMS_LEADERBOARD_REPORT_SUCCEEDED,
  FETCHING_TEAMS_LEARNERS_REPORT_FAILED,
  FETCHING_TEAMS_LEARNERS_REPORT_SUCCEEDED,
  FETCHING_TEAMS_LEARNINGS_REPORT_FAILED,
  FETCHING_TEAMS_LEARNINGS_REPORT_SUCCEEDED,
  FETCHING_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_FAILED,
  FETCHING_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_SUCCEEDED,
} from "../actionTypes";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_COACHING_API_URL}`;

//Fetch Learnings
export const fetchTeamsLearningsReport = createAction<FetchTeamsLearningsRequest>(FETCH_TEAMS_LEARNINGS_REPORT_REQUEST);
const fetchingLearningsReportSucceeded = createAction<FetchTeamsLearningsResponse>(FETCHING_TEAMS_LEARNINGS_REPORT_SUCCEEDED);
const fetchingLearningsReportFailed = createAction<FetchTeamsLearningsErrorResponse>(FETCHING_TEAMS_LEARNINGS_REPORT_FAILED);

const fetchTeamsLearningsReportSaga = function* (action: ReturnType<typeof fetchTeamsLearningsReport>): any {
  let {query, page, limit, startDate, endDate, sort} = action.payload as any;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/reports/learnings`,
  });

  if (!sort) {
    sort = {
      orderBy: 'ASC',
      sortBy: 'learners'
    }
  }
 
  const fetchTeamsLearningsReportAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: {
        query: query,
        page: page,
        limit: limit,
        startDate: startDate,
        endDate: endDate,
        sortType: sort.sortBy,
        orderBy: sort.orderBy
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTeamsLearningsReportAPI);
    yield put(fetchingLearningsReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingLearningsReportFailed({error: error }));
  }
};

//Fetch Learners
export const fetchTeamsLearnersReport = createAction<FetchTeamsLearnersRequest>(FETCH_TEAMS_LEARNERS_REPORT_REQUEST);
const fetchingLearnersReportSucceeded = createAction<FetchTeamsLearnersResponse>(FETCHING_TEAMS_LEARNERS_REPORT_SUCCEEDED);
const fetchingLearnersReportFailed = createAction<FetchTeamsLearnersErrorResponse>(FETCHING_TEAMS_LEARNERS_REPORT_FAILED);

const fetchLearnersReportSaga = function* (action: ReturnType<typeof fetchTeamsLearnersReport>): any {
  let {query, page, limit, startDate, endDate, sort} = action.payload as any;

  let url = buildUrl(apiUrl, {
    path: `api/1.0/reports/learners`,
  });

  if (!sort) {
    sort = {
      orderBy: 'ASC',
      sortBy: 'enrolled'
    }
  }
 
  const fetchLearnersReportAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: {
        query: query,
        page: page,
        limit: limit,
        startDate: startDate,
        endDate: endDate,
        sortType: sort.sortBy,
        orderBy: sort.orderBy
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLearnersReportAPI);
    yield put(fetchingLearnersReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingLearnersReportFailed({error: error }));
  }
};

//Fetch Leaderboard
// same response as Fetch Learners
export const fetchTeamsLeaderboardReport = createAction<FetchTeamsLearnersRequest>(FETCH_TEAMS_LEADERBOARD_REPORT_REQUEST);
const fetchingTeamsLeaderboardReportSucceeded = createAction<FetchTeamsLearnersResponse>(FETCHING_TEAMS_LEADERBOARD_REPORT_SUCCEEDED);
const fetchingTeamsLeaderboardReportFailed = createAction<FetchTeamsLearnersErrorResponse>(FETCHING_TEAMS_LEADERBOARD_REPORT_FAILED);

const fetchTeamsLeaderboardReportSaga = function* (action: ReturnType<typeof fetchTeamsLeaderboardReport>): any {
  const {query, page, limit, startDate, endDate,} = action.payload as any;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/reports/leaderboard`,
    queryParams: {
      page: page,
      limit: limit,
      startDate: startDate,
      endDate: endDate,
    }
  });
 
  const fetchLeaderboardReportAPI = () => {
    return axios({
      method: 'GET',
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLeaderboardReportAPI);
    yield put(fetchingTeamsLeaderboardReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingTeamsLeaderboardReportFailed({error: error }));
  }
};

//Dashboard Report
export const fetchTeamsDashboardReport = createAction<FetchTeamsDashboardRequest>(FETCH_TEAMS_DASHBOARD_REPORT_REQUEST);
const fetchingTeamsDashboardReportSucceeded = createAction<FetchTeamsDashboardResponse>(FETCHING_TEAMS_DASHBOARD_REPORT_SUCCEEDED);
const fetchingTeamsDashboardReportFailed = createAction<FetchTeamsDashboardErrorResponse>(FETCHING_TEAMS_DASHBOARD_REPORT_FAILED);

const fetchsDashboardReportSaga = function* (action: ReturnType<typeof fetchTeamsDashboardReport>): any {
  const {startDate, endDate,} = action.payload as FetchTeamsDashboardRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/reports/dashboard`
  });
 
  const fetchDashboardReportAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: {
        startDate: startDate,
        endDate: endDate
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDashboardReportAPI);
    yield put(fetchingTeamsDashboardReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingTeamsDashboardReportFailed({error: error }));
  }
};

// skills acquired by the team
export const fetchTeamsSkillReport = createAction<FetchTeamsSkillsRequest>(FETCH_SKILLS_REPORT_REQUEST);
const fetchingTeamsSkillsReportSucceeded = createAction<FetchTeamsSkillsResponse>(FETCHING_SKILLS_REPORT_SUCCEEDED);
const fetchingTeamsSkillReportFailed = createAction<FetchTeamsSkillsErrorResponse>(FETCHING_SKILLS_REPORT_FAILED);

const fetchsSkillsReportSaga = function* (action: ReturnType<typeof fetchTeamsSkillReport>): any {
  const {page, limit, startDate, endDate} = action.payload as any;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/reports/skills/teams`,
    queryParams: {
      page: page,
      limit: limit,
      startDate: startDate,
      endDate: endDate,
    }
  });
 
  const fetchSkillsReportAPI = () => {
    return axios({
      method: 'GET',
      url: url
    }).then((response) => response.data);
  };
  try {
    const response = yield call(fetchSkillsReportAPI);
    yield put(fetchingTeamsSkillsReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingTeamsSkillReportFailed({error: error }));
  }
};

// skills acquired by the team in learnings
export const fetchLearningsSkillsReport = createAction<FetchTeamsSkillsRequest>(FETCH_LEARNINGS_SKILLS_REPORT_REQUEST);
const fetchingLearningsSkillsReportSucceeded = createAction<FetchTeamsSkillsResponse>(FETCHING_LEARNINGS_SKILLS_REPORT_SUCCEEDED);
const fetchingLearningsSkillReportFailed = createAction<FetchTeamsSkillsErrorResponse>(FETCHING_LEARNINGS_SKILLS_REPORT_FAILED);

const fetchLearningsSkillsReportSaga = function* (action: ReturnType<typeof fetchTeamsSkillReport>): any {
  const {page, limit, startDate, endDate} = action.payload as any;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/reports/skills/learnings`,
    queryParams: {
      page: page,
      limit: limit,
      startDate: startDate,
      endDate: endDate,
    }
  });
 
  const fetchSkillsReportAPI = () => {
    return axios({
      method: 'GET',
      url: url
    }).then((response) => response.data);
  };
  try {
    const response = yield call(fetchSkillsReportAPI);
    yield put(fetchingLearningsSkillsReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingLearningsSkillReportFailed({error: error }));
  }
};

//Learnings Most Enrolled Report
export const fetchTeamsMostEnrolledLearningsReport = createAction<FetchTeamsMostEnrolledLearningsRequest>(FETCH_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_REQUEST);
const fetchingTeamsMostEnrolledLearningsReportSucceeded = createAction<FetchTeamsMostEnrolledLearningsResponse>(FETCHING_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_SUCCEEDED);
const fetchingTeamsMostEnrolledLearningsReportFailed = createAction<FetchTeamsMostEnrolledLearningsErrorResponse>(FETCHING_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_FAILED);

const fetchsMostEnrolledReportSaga = function* (action: ReturnType<typeof fetchTeamsMostEnrolledLearningsReport>): any {
  const {startDate, endDate,} = action.payload as FetchTeamsDashboardRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/reports/learnings/most-enrolled`
  });
 
  const fetchMostEnrolledReportAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: {
        startDate: startDate,
        endDate: endDate
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchMostEnrolledReportAPI);
    yield put(fetchingTeamsMostEnrolledLearningsReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingTeamsMostEnrolledLearningsReportFailed({error: error }));
  }
};

// Learnings Reports
//Dashboard Report
export const fetchLearningsDashboardReport = createAction<FetchTeamsDashboardRequest>(FETCH_LEARNINGS_DASHBOARD_REPORT_REQUEST);
const fetchingLearningsDashboardReportSucceeded = createAction<FetchTeamsDashboardResponse>(FETCHING_LEARNINGS_DASHBOARD_REPORT_SUCCEEDED);
const fetchingLearningsDashboardReportFailed = createAction<FetchTeamsDashboardErrorResponse>(FETCHING_LEARNINGS_DASHBOARD_REPORT_FAILED);

const fetchLearningsDashboardReportSaga = function* (action: ReturnType<typeof fetchLearningsDashboardReport>): any {
  const {startDate, endDate, user} = action.payload as FetchTeamsDashboardRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/reports/dashboard`
  });
 
  const fetchDashboardReportAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: {
        startDate: startDate,
        endDate: endDate,
        user: user
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDashboardReportAPI);
    yield put(fetchingLearningsDashboardReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingLearningsDashboardReportFailed({error: error }));
  }
};


//Fetch Leaderboard
export const fetchLearningsLeaderboardReport = createAction<FetchTeamsLearnersRequest>(FETCH_LEARNINGS_LEADERBOARD_REPORT_REQUEST);
const fetchingLearningsLeaderboardReportSucceeded = createAction<FetchTeamsLearnersResponse>(FETCHING_LEARNINGS_LEADERBOARD_REPORT_SUCCEEDED);
const fetchingLearningsLeaderboardReportFailed = createAction<FetchTeamsLearnersErrorResponse>(FETCHING_LEARNINGS_LEADERBOARD_REPORT_FAILED);

const fetchLearningsLeaderboardReportSaga = function* (action: ReturnType<typeof fetchLearningsLeaderboardReport>): any {
  const {query, page, limit, startDate, endDate,} = action.payload as any;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/reports/leaderboard`,
    queryParams: {
      page: page,
      limit: limit,
      startDate: startDate,
      endDate: endDate,
    }
  });
 
  const fetchLeaderboardReportAPI = () => {
    return axios({
      method: 'GET',
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLeaderboardReportAPI);
    yield put(fetchingLearningsLeaderboardReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingLearningsLeaderboardReportFailed({error: error }));
  }
};

//Learnings Most Enrolled Report
export const fetchLearningsPopularReport = createAction<FetchTeamsMostEnrolledLearningsRequest>(FETCH_LEARNINGS_POPULAR_REPORT_REQUEST);
const fetchingLearningsPopularReportSucceeded = createAction<FetchTeamsMostEnrolledLearningsResponse>(FETCHING_LEARNINGS_POPULAR_REPORT_SUCCEEDED);
const fetchingLearningsPopularReportFailed = createAction<FetchTeamsMostEnrolledLearningsErrorResponse>(FETCHING_LEARNINGS_POPULAR_REPORT_FAILED);

const fetchLearningsPopularReportSaga = function* (action: ReturnType<typeof fetchLearningsPopularReport>): any {
  const {startDate, endDate,} = action.payload as FetchTeamsDashboardRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/reports/learnings/most-enrolled`
  });
 
  const fetchPopularLearningsAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: {
        startDate: startDate,
        endDate: endDate
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPopularLearningsAPI);
    yield put(fetchingLearningsPopularReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingLearningsPopularReportFailed({error: error }));
  }
};

//Fetch Insights
export const fetchLearningsInsightsReport = createAction<FetchTeamsLearningsRequest>(FETCH_LEARNINGS_INSIGHTS_REPORT_REQUEST);
const fetchingInsightsReportSucceeded = createAction<FetchTeamsLearningsResponse>(FETCHING_LEARNINGS_INSIGHTS_REPORT_SUCCEEDED);
const fetchingInsightsReportFailed = createAction<FetchTeamsLearningsErrorResponse>(FETCHING_LEARNINGS_INSIGHTS_REPORT_FAILED);

const fetchLearningsInsightsReportSaga = function* (action: ReturnType<typeof fetchLearningsInsightsReport>): any {
  let {query, page, limit, startDate, endDate, user, sort} = action.payload as any;

  let url = buildUrl(apiUrl, {
    path: `api/1.0/reports/learnings`,
  });

  if (!sort) {
    sort = {
      orderBy: 'ASC',
      sortBy: 'learners'
    }
  }
 
  const fetchLearningsInsightsReportAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: {
        query: query,
        page: page,
        limit: limit,
        startDate: startDate,
        endDate: endDate,
        user: user,
        sortType: sort.sortBy,
        orderBy: sort.orderBy
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLearningsInsightsReportAPI);
    yield put(fetchingInsightsReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingInsightsReportFailed({error: error }));
  }
};


// creations reports

//Dashboard Report
export const fetchCreationsDashboardReport = createAction<FetchTeamsDashboardRequest>(FETCH_CREATIONS_DASHBOARD_REPORT_REQUEST);
const fetchingCreationsDashboardReportSucceeded = createAction<FetchTeamsDashboardResponse>(FETCHING_CREATIONS_DASHBOARD_REPORT_SUCCEEDED);
const fetchingCreationsDashboardReportFailed = createAction<FetchTeamsDashboardErrorResponse>(FETCHING_CREATIONS_DASHBOARD_REPORT_FAILED);

const fetchCreationsDashboardReportSaga = function* (action: ReturnType<typeof fetchCreationsDashboardReport>): any {
  const {startDate, endDate, user} = action.payload as FetchTeamsDashboardRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/reports/dashboard`
  });
 
  const fetchDashboardReportAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: {
        startDate: startDate,
        endDate: endDate,
        user: user
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDashboardReportAPI);
    yield put(fetchingCreationsDashboardReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingCreationsDashboardReportFailed({error: error }));
  }
};

export const fetchCreationsTopLearningsReport = createAction<FetchTeamsMostEnrolledLearningsRequest>(FETCH_CREATIONS_TOP_LEARNINGS_REPORT_REQUEST);
const fetchingCreationsTopLearningsReportSucceeded = createAction<FetchTeamsMostEnrolledLearningsResponse>(FETCHING_CREATIONS_TOP_LEARNINGS_REPORT_SUCCEEDED);
const fetchingCreationsTopLearningsReportFailed = createAction<FetchTeamsMostEnrolledLearningsErrorResponse>(FETCHING_CREATIONS_TOP_LEARNINGS_REPORT_FAILED);

const fetchCreationsTopLearningsReportSaga = function* (action: ReturnType<typeof fetchCreationsTopLearningsReport>): any {
  const {startDate, endDate,} = action.payload as FetchTeamsDashboardRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/reports/learnings/most-enrolled`
  });
 
  const fetchTopLearningsReportAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: {
        startDate: startDate,
        endDate: endDate
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTopLearningsReportAPI);
    yield put(fetchingCreationsTopLearningsReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingCreationsTopLearningsReportFailed({error: error }));
  }
};

//Fetch Insights
export const fetchCreationsLearningsInsightsReport = createAction<FetchTeamsLearningsRequest>(FETCH_CREATIONS_LEARNINGS_INSIGHTS_REPORT_REQUEST);
const fetchingCreationsLearningsInsightsReportSucceeded = createAction<FetchTeamsLearningsResponse>(FETCHING_CREATIONS_LEARNINGS_INSIGHTS_REPORT_SUCCEEDED);
const fetchingCreationsLearningsInsightsReportFailed = createAction<FetchTeamsLearningsErrorResponse>(FETCHING_CREATIONS_LEARNINGS_INSIGHTS_REPORT_FAILED);

const fetchCreationsLearningsInsightsReportSaga = function* (action: ReturnType<typeof fetchCreationsLearningsInsightsReport>): any {
  let {query, page, limit, startDate, endDate, user, sort} = action.payload as any;

  let url = buildUrl(apiUrl, {
    path: `api/1.0/reports/learnings`,
  });

  if (!sort) {
    sort = {
      orderBy: 'ASC',
      sortBy: 'learners'
    }
  }
 
  const fetchCreationsInsightsReportAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: {
        query: query,
        page: page,
        limit: limit,
        startDate: startDate,
        endDate: endDate,
        user: user,
        sortType: sort.sortBy,
        orderBy: sort.orderBy
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCreationsInsightsReportAPI);
    yield put(fetchingCreationsLearningsInsightsReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingCreationsLearningsInsightsReportFailed({error: error }));
  }
};

//Fetch Learners
export const fetchCreationsLearnersReport = createAction<FetchTeamsLearningsRequest>(FETCH_CREATIONS_LEARNERS_REPORT_REQUEST);
const fetchingCreationsLearnersReportSucceeded = createAction<FetchTeamsLearningsResponse>(FETCHING_CREATIONS_LEARNERS_REPORT_SUCCEEDED);
const fetchingCreationsLearnersReportFailed = createAction<FetchTeamsLearningsErrorResponse>(FETCHING_CREATIONS_LEARNERS_REPORT_FAILED);

const fetchCreationsLearnersReportSaga = function* (action: ReturnType<typeof fetchCreationsLearnersReport>): any {
  const {query, page, limit, startDate, endDate, user} = action.payload as any;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/reports/learners`,
  });
 
  const fetchCreationsLearnersReportAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: {
        query: query,
        page: page,
        limit: limit,
        startDate: startDate,
        endDate: endDate,
        user: user,
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCreationsLearnersReportAPI);
    yield put(fetchingCreationsLearnersReportSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingCreationsLearnersReportFailed({error: error }));
  }
};

export default function* coachingReportsSaga () {
  yield takeEvery(FETCH_TEAMS_LEARNINGS_REPORT_REQUEST, fetchTeamsLearningsReportSaga);
  yield takeEvery(FETCH_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_REQUEST, fetchsMostEnrolledReportSaga);
  yield takeEvery(FETCH_TEAMS_LEARNERS_REPORT_REQUEST, fetchLearnersReportSaga);
  yield takeEvery(FETCH_TEAMS_LEADERBOARD_REPORT_REQUEST, fetchTeamsLeaderboardReportSaga);
  yield takeEvery(FETCH_TEAMS_DASHBOARD_REPORT_REQUEST, fetchsDashboardReportSaga);
  yield takeEvery(FETCH_SKILLS_REPORT_REQUEST, fetchsSkillsReportSaga);

  yield takeEvery(FETCH_LEARNINGS_DASHBOARD_REPORT_REQUEST, fetchLearningsDashboardReportSaga);
  yield takeEvery(FETCH_LEARNINGS_LEADERBOARD_REPORT_REQUEST, fetchLearningsLeaderboardReportSaga);
  yield takeEvery(FETCH_LEARNINGS_POPULAR_REPORT_REQUEST, fetchLearningsPopularReportSaga);
  yield takeEvery(FETCH_LEARNINGS_TIMELINE_REPORT_REQUEST, fetchsMostEnrolledReportSaga);
  yield takeEvery(FETCH_LEARNINGS_INSIGHTS_REPORT_REQUEST, fetchLearningsInsightsReportSaga); 
  yield takeEvery(FETCH_LEARNINGS_SKILLS_REPORT_REQUEST, fetchLearningsSkillsReportSaga);

  yield takeEvery(FETCH_CREATIONS_DASHBOARD_REPORT_REQUEST, fetchCreationsDashboardReportSaga);
  yield takeEvery(FETCH_CREATIONS_TOP_LEARNINGS_REPORT_REQUEST, fetchCreationsTopLearningsReportSaga);
  yield takeEvery(FETCH_CREATIONS_LEARNINGS_INSIGHTS_REPORT_REQUEST, fetchCreationsLearningsInsightsReportSaga);
  yield takeEvery(FETCH_CREATIONS_LEARNERS_REPORT_REQUEST, fetchCreationsLearnersReportSaga);
}